var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0568 2.0002C8.54687 1.98602 5.28557 3.80716 3.4605 6.80047C1.63543 9.79378 1.51292 13.5225 3.13757 16.6288L3.33789 17.0192C3.50209 17.3265 3.53644 17.6865 3.43329 18.0192C3.14742 18.7785 2.90849 19.5546 2.71784 20.343C2.71784 20.743 2.83231 20.9716 3.26158 20.9621C4.0219 20.7942 4.77068 20.5779 5.50332 20.3145C5.81886 20.2276 6.15437 20.2477 6.45725 20.3716C6.73389 20.5049 7.2967 20.8478 7.31578 20.8478C10.9915 22.7806 15.4808 22.2473 18.5998 19.5075C21.7187 16.7677 22.8199 12.3901 21.3676 8.50416C19.9153 4.61821 16.2111 2.03065 12.0568 2.0002V2.0002Z",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28751 12.4764C7.55093 12.4764 7.76448 12.2632 7.76448 12.0002C7.76448 11.7372 7.55093 11.524 7.28751 11.524C7.02409 11.524 6.81055 11.7372 6.81055 12.0002C6.81055 12.2632 7.02409 12.4764 7.28751 12.4764Z",
    fill: "#9295A3",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.057 12.4764C12.3205 12.4764 12.534 12.2632 12.534 12.0002C12.534 11.7372 12.3205 11.524 12.057 11.524C11.7936 11.524 11.5801 11.7372 11.5801 12.0002C11.5801 12.2632 11.7936 12.4764 12.057 12.4764Z",
    fill: "#9295A3",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8266 12.4764C17.09 12.4764 17.3035 12.2632 17.3035 12.0002C17.3035 11.7372 17.09 11.524 16.8266 11.524C16.5632 11.524 16.3496 11.7372 16.3496 12.0002C16.3496 12.2632 16.5632 12.4764 16.8266 12.4764Z",
    fill: "#9295A3",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4cd25a1deaf0001a2912e0b1a1fb1e3f.svg";
export { ForwardRef as ReactComponent };